<div class="row g-0 mb-4">
	<div class="col-2 text-end">
		<small class="text-muted"><%= Anvil.moment(issue.insert_dt).format('YYYY. MM. DD. HH:mm') %></small>
	</div>
	<div class="col-auto text-center" style="width:50px;">
		<div class="timeline-indicator">
			<% for (const work_tag_id of issue.work_tags) { const tag = Anvil.page.modal.issue_tags.getById(work_tag_id); %>
				<div class="timeline-icon">
					<i class="<%= tag.icon %>" style="color:<%= tag.color %>;" title="<%= tag.name %>"></i>
				</div>
			<% } %>
		</div>
	</div>
	<div class="col p-2" style="background-color:rgba(0, 0, 0, 0.15); border-radius:5px;">
		<p class="mb-3"><strong><%= issue.title %></strong></p>

		<%- issue.description.replaceAll(/(?:\r\n|\r|\n)/g, '<br />') %>
	</div>
</div>

<% for (const note of issue.notes) { %>
<div class="row g-0 mb-4">
	<div class="col-2 text-end" style="overflow:hidden; text-overflow:ellipsis;">
		<strong><%= Anvil.page.modal.users.getById(note.insert_user_id)?.account_name || '[ismeretlen szerző]' %></strong><br />
		<small class="text-muted"><%= Anvil.moment(note.insert_dt).format('YYYY. MM. DD. HH:mm') %></small>
	</div>
	<div class="col-auto text-center" style="width:50px;">
		<div class="timeline-indicator">
			<div class="timeline-icon">
				<i class="fa fa-user fa-fw"></i>
			</div>
		</div>
	</div>
	<div class="col p-2" style="background-color:rgba(0, 0, 0, 0.1); border-radius:5px;">

		<% if (!issue.closed) { %>
		<div class="dropdown float-end mt-n1 me-n1 ms-1">
			<button class="btn btn-sm btn-link" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-caret-down"></i></button>
			<div class="dropdown-menu">
				<button class="dropdown-item py-2" onclick="Anvil.page.modal.editComment(<%= note.id %>)"><i class="fa fa-fw fa-edit me-2"></i>Szerkesztés</button>
				<div class="dropstart">
					<button class="dropdown-item py-2" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-trash me-2"></i>Törlés</button>
					<div class="dropdown-menu dropdown-menu-start px-3">
						<p>Biztosan törlöd ezt a megjegyzést?</p>
						<button class="btn btn-sm btn-dark text-danger w-100" onclick="Anvil.page.modal.deleteComment(<%= note.id %>, true)"><i class="fa fa-fw fa-trash"></i> Igen, törlöm!</button>
					</div>
				</div>
			</div>
		</div>
		<% } %>

		<%- note.description.replaceAll(/(?:\r\n|\r|\n)/g, '<br />') %>

		<% if (note.update_dt) { %>
			<hr class="mt-3 mb-0" />
			<small class="text-dim">Módosította: <%= Anvil.page.modal.users.getById(note.update_user_id)?.account_name || '[ismeretlen felhasználó]' %> - <%= Anvil.moment(note.update_dt).format('YYYY. MM. DD. HH:mm') %></small>
		<% } %>
	</div>
</div>
<% } %>

<% if (issue.closed) { %>
	<div class="row g-0 mb-4">
		<div class="col-2 text-end">
			<small class="text-muted"><%= Anvil.moment(issue.update_dt || issue.insert_dt).format('YYYY. MM. DD. HH:mm') %></small>
		</div>
		<div class="col-auto text-center" style="width:50px;">
			<div class="timeline-indicator">
				<div class="timeline-icon">
					<i class="fa fa-lock fa-fw text-success"></i>
				</div>
			</div>
		</div>
		<div class="col p-2" style="background-color:rgba(0, 0, 0, 0.1); border-radius:5px;">
			Lezárva
		</div>
	</div>
<% } %>